import { StatCard, useTranslation } from '@hbs-us/ui';

import type { MoneyFormatters } from '../../_money/useMoneyFormatters.js';

/**
 * The 2-card summary stat grid on the invoices list (UI-SPEC Invoices feature
 * folder): **Outstanding Balance** (`--chart-4` amber) and **Overdue**
 * (`--destructive` red). Values are the server-computed rollups from the coarse
 * endpoint (no client re-aggregation). CSS grid + region/list semantics (NOT a
 * layout table — A11Y-01); numerals in IBM Plex Mono.
 */

function SummaryStatCard({
  label,
  value,
  sub,
  valueClassName,
}: {
  label: string;
  value: string;
  sub: string;
  valueClassName: string;
}) {
  return (
    <StatCard
      label={label}
      value={<span className={valueClassName}>{value}</span>}
      footnote={sub}
    />
  );
}

export function InvoiceSummaryCards({
  totalOutstanding,
  totalOverdue,
  fmt,
}: {
  totalOutstanding: number;
  totalOverdue: number;
  fmt: MoneyFormatters;
}) {
  const { t } = useTranslation();

  return (
    <section
      aria-label={t('invoices:summary.regionLabel')}
      className="mb-4 grid grid-cols-1 gap-4 sm:grid-cols-2"
    >
      <SummaryStatCard
        label={t('invoices:summary.outstanding')}
        value={fmt.formatCurrency(totalOutstanding)}
        sub={t('invoices:summary.outstandingSub')}
        valueClassName="text-foreground"
      />
      <SummaryStatCard
        label={t('invoices:summary.overdue')}
        value={fmt.formatCurrency(totalOverdue)}
        sub={t('invoices:summary.overdueSub')}
        valueClassName="text-destructive"
      />
    </section>
  );
}
